export default {
    name: "sendBillInvalidManage",
	mounted: function () {
		this.init();
	},
    data() {
        return {
            searchForm: {
                recName: null,
                state: null,
                page: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0
        }
    },
    methods: {
		init(){
            let conditionParam = this.$routerUtil.getParam();
            if(conditionParam && conditionParam.searchForm){
                conditionParam = conditionParam.searchForm;
            }
			console.log(conditionParam);
			this.$routerUtil.clearParam();
			if(conditionParam){
                this.$nextTick(() => {
                    this.searchForm = conditionParam;
                    this.doSearch();
                });
			}
		},
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.page = val;
            this.doSearch();
        },
		rowClick(row){
			this.$refs.table.toggleRowSelection(row);
		},
        handleSelectionChange(val) {
            this.selected = val;
        },
        doReset(){
			this.searchForm.recName="";
			this.searchForm.sendName="";
			this.searchForm.state="";
		},
		doAdditionalPrinting(){
			
		},
        doSearch() {
            this.tableData.splice(0, this.tableData.length);
            for(let i=0;i<this.searchForm.pageSize;i++){
                this.tableData.push({
                    table_blCode: '收单提单测试' + ((this.searchForm.page-1) * this.searchForm.pageSize + i),
                    table_sendCustomerCompany: '1',
                    table_recCustomerCompany: '1',
					table_isSignature: '1',
					table_recReviewedResult: '1',
					table_isApplyPrint: '1',
					table_SysPrintApplyResult: '1',
					table_isPostaged: '1',
                    table_pageCount: '1',
                    table_createDate: '1',
                    table_state: '1'
                });
            }
            this.total = 1651
        },
        doDetail(){
            const row = this.getSelectedRow();
			if (row) {
				const conditionData = new Object();
				conditionData.searchForm = this.searchForm;
				conditionData.row = row;
				this.$router.push('BillDetail');
				this.$routerUtil.setParam(conditionData);
			}
        },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        }
    }
}
